import Render from '@Views/components/popin/layout/popin-referral-convert-point.html'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Render
@Component({})
export class PopinReferralConvertPoint extends Vue {
	private static max_convertible_points: number = 4
    @Prop() options: {point: number, months: string}
	@Prop({default: true}) submitted: boolean

	remainingPoint: number = 0;
	get hasMoreThanFourReferralPoints(): boolean {
		return this.options.point > PopinReferralConvertPoint.max_convertible_points
	}

	mounted(){
		this.remainingPoint = this.options.point - PopinReferralConvertPoint.max_convertible_points;
	}

}
